import { createContext, ReactNode, useContext } from 'react';

interface ShellChrome {
  /**
   * Leading action supplied by the nav shell (e.g. the sidebar toggle),
   * injected into `AppPageLayout`'s top bar so screens don't wire it per-screen.
   */
  leadingAction?: ReactNode;
}

const ShellChromeContext = createContext<ShellChrome>({});

/**
 * Provided by the experience shell (e.g. `SalesHubShellTemplate`), consumed by
 * `AppPageLayout`. Keeps `AppPageLayout` experience-agnostic: it renders whatever
 * leading action the shell hands down, without knowing about sidebars.
 */
export const ShellChromeProvider = ShellChromeContext.Provider;

export const useShellChrome = (): ShellChrome => useContext(ShellChromeContext);
